import { EVENTS_MARKETS } from './catalogEvents.js';
import { HALFTIME_MARKETS } from './catalogHalftime.js';
import { SCORE_MARKETS } from './catalogScore.js';
// Leg display order is by ascending multiplier (safe → bold) so the picker reads as
// a risk gradient. The `outcome` anchor leads.
const DEFS = [...SCORE_MARKETS, ...HALFTIME_MARKETS, ...EVENTS_MARKETS];
/** Every market, keyed by id. */
export const MARKETS = Object.freeze(Object.fromEntries(DEFS.map((d) => [d.id, d])));
/** The catalog in stable display order. */
export const MARKET_LIST = DEFS;
/** The always-present anchor question every fixture asks (the 1X2 qualifier). */
export const ANCHOR_MARKET_ID = 'outcome';
/** Every market id eligible to be stacked as a LEG (everything but the anchor), in
 *  display order (ascending multiplier). The fixture's `legCatalog` is this list
 *  filtered by the league's provider coverage. */
export const LEG_MARKET_IDS = DEFS.filter((d) => !d.anchor).map((d) => d.id);
// Startup invariant: every leg market must resolve to a multiplier > 1 — either a
// FLAT `multiplier`, or (for per-outcome markets) a multiplier on EVERY option.
// Throwing here turns a missing/zero multiplier into a loud crash, not silent free legs.
for (const id of LEG_MARKET_IDS) {
    const m = MARKETS[id];
    if (m.multiplier != null) {
        if (!(m.multiplier > 1)) {
            throw new Error(`Market "${id}" is a leg but its flat multiplier (${m.multiplier}) is not > 1.`);
        }
    }
    else if (m.options && m.options.length > 0) {
        for (const o of m.options) {
            if (!(o.multiplier && o.multiplier > 1)) {
                throw new Error(`Market "${id}" option "${o.value}" has no per-outcome multiplier > 1.`);
            }
        }
    }
    else {
        throw new Error(`Market "${id}" is a leg but has neither a flat nor per-outcome multiplier.`);
    }
}
/** Look up a market def by id (undefined for an unknown/legacy id). */
export function getMarket(id) {
    return MARKETS[id];
}
//# sourceMappingURL=registry.js.map